/* Qué apertura de WhatsApp va a salir cuando alguien aprieta Enviar. La elige cada persona en la
 * cola y se recuerda en este navegador; si la recordada ya no se puede mandar (Meta la rechazó,
 * se sacó del código), vuelve a la de `WHATSAPP_PLANTILLA`. */
import { useCallback, useEffect, useState } from "react";

import { useDatos } from "./api";
import type { Apertura, Aperturas } from "./tipos";

const CLAVE = "prospeccion:plantilla";

function leerGuardada(): string | null {
  try {
    return localStorage.getItem(CLAVE);
  } catch {
    return null;
  }
}

export const usable = (a: Apertura) => a.estado === "aprobada" || a.estado === null;

export function usePlantillaElegida() {
  const { datos: aperturas, error, recargar } = useDatos<Aperturas>("/api/aperturas");
  const [guardada, setGuardada] = useState<string | null>(leerGuardada);

  const elegir = useCallback((nombre: string) => {
    setGuardada(nombre);
    try {
      localStorage.setItem(CLAVE, nombre);
    } catch {
      // sin almacenamiento (ventana privada): vale sólo para esta pantalla
    }
  }, []);

  // La elegida, si sigue en la lista y se puede mandar; si no, la por defecto.
  const candidata = aperturas?.lista.find((a) => a.nombre === guardada);
  const elegida: Apertura | null = candidata && usable(candidata) ? candidata : (aperturas?.lista.find((a) => a.nombre === aperturas.porDefecto) ?? aperturas?.lista[0] ?? null);

  useEffect(() => {
    if (aperturas && elegida && guardada !== elegida.nombre) setGuardada(elegida.nombre);
  }, [aperturas, elegida, guardada]);

  return { aperturas, elegida, elegir, error, recargar };
}
